'use es6';

export function setMockAuth(mocked) {
  return (options) => ({ ...options, mockAuth: mocked });
}
